import { PangoUser as User } from 'sdk/user';
import { firebaseClientConfig } from './firebase/client';

export default new User(firebaseClientConfig);
